import { M8UserProfileUpdate } from 'services/production/types';
import { normalizeOrgStaffCount } from 'services/production/utils/normalizeOrgStaffCount';
import { ClientProfileFormValues } from 'types/state';
import { RESIDENT_COUNTRY_CODE } from 'utils/constants';

export const normalizeClientProfileFormValues = (
  values: ClientProfileFormValues
) => ({
  toM8UserProfileUpdate: (): M8UserProfileUpdate => {
    if (values.location === null) {
      throw new TypeError();
    }

    return {
      firstName: values.firstName,
      lastName: values.lastName,
      middleName: values.middleName,
      position: values.position,
      organization: values.company,
      companySize: values.orgStaffCount
        ? normalizeOrgStaffCount(values.orgStaffCount).toCompanySize()
        : 'UNDEFINED',
      phone: values.phone,
      resident: values.location === RESIDENT_COUNTRY_CODE,
      country: values.location,
    };
  },
});
